import React, { useEffect, useState } from "react";

import Paper from "@mui/material/Paper";

import useNotify from "../../utils/useNotify";

import { getOrgDocs } from "../../services/httpCalls";
import { Box, Typography } from "@mui/material";
import { Table } from "antd";
import ShowDetailedView from "./ShowDetailedView";
import ShowDocs from "./ShowDocs";
import { DateConvert } from "../../utils/dateConverter";

const cols = [
  {
    colName: "File Name",
    colId: "name",
  },
  {
    colName: "File Type",
    colId: "file type",
  },

  {
    colName: "Download",
    colId: "download",
  },
];
const DocumentsSignup = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = (e) => {
    setOpen(true);

    setDocs(e?.kycDocumentsRedisData);
  };
  const handleClose = () => setOpen(false);
  const [docs, setDocs] = useState();
  const [signupDocsData, setSignupDocsData] = useState();
  const notify = useNotify();
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const getAllData = async () => {
      await getOrgDocs()
        .then((res) => {
          if (res.length) {
            setSignupDocsData(res);
            setTotalCount(res.length);
          }
        })
        .catch((err) => {});
    };
    getAllData();
  }, []);

  const colsSignup = [
    {
      title: "Legal Name",
      align: "center",
      width: 200,
      render: (record) =>
        record?.organisationSignupDataRedis?.corporateKycDetails?.legalName !==
        null
          ? record?.organisationSignupDataRedis?.corporateKycDetails.legalName
          : "-",
    },

    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      width: 150,
      // ellipsis: true,
    },
    {
      title: "PAN",
      dataIndex: "pan",
      width: 140,
      align: "center",
      ellipsis: true,
      // render: (record) =>
      //   record?.organisationSignupDataRedis?.corporateKycDetails?.panNumber !==
      //   null
      //     ? record?.organisationSignupDataRedis?.corporateKycDetails.panNumber
      //     : "-",
    },
    {
      title: "Current Stage",
      align: "center",
      ellipsis: true,
      width: 120,
      render: (record) =>
        record?.organisationSignupDataRedis?.currentStage !== null
          ? record?.organisationSignupDataRedis?.currentStage.toLowerCase()
          : "-",
    },
    {
      title: "Creation Date",
      align: "center",

      width: 120,
      render: (record) =>
        record?.organisationSignupDataRedis?.creationDate !== null
          ? DateConvert(record?.organisationSignupDataRedis?.creationDate)
          : "-",
    },
    {
      title: "Detailed View",
      align: "center",
      width: 115,

      render: (record) => (
        <ShowDetailedView
          organizationData={record?.organisationSignupDataRedis}
        />
      ),
    },
    {
      title: "Documents",
      align: "center",
      width: 110,
      render: (record) => <ShowDocs email={record?.email} pan={record?.pan} />,
    },
  ];

  return (
    <div>
      <div className="docs_heading">
        <Typography
          variant="h5"
          sx={{ paddingBottom: "1rem", fontWeight: 400 }}
        >
          Signup Profiles
        </Typography>
      </div>
      <Box
        sx={{
          padding: ".5rem 0",
        }}
      >
        <Box component={Paper}>
          <Table
            columns={colsSignup}
            dataSource={signupDocsData}
            rowKey={(record) =>
              record?.organisationSignupDataRedis?.creationDate
            }
            className="styledAntd"
            pagination={{
              total: totalCount,
              pageSize: 10,
              showSizeChanger: false,
              position: ["bottomCenter"],
            }}
          />
        </Box>
      </Box>
    </div>
  );
};

export default DocumentsSignup;
